export const MAX_FILES = 10;
export const MAX_TOTAL_BYTES = 10 * 1024 * 1024;
export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];

export type AttachmentError = {
  kind: 'type' | 'size' | 'empty' | 'count';
  message: string;
};

const extOf = (name: string) => name.split('.').pop()?.toLowerCase() ?? '';

export function validateAttachments(
  existing: File[],
  incoming: File[]
): { accepted: File[]; error?: AttachmentError } {
  const badType = incoming.find(
    (f) => !ALLOWED_EXTENSIONS.includes(extOf(f.name))
  );
  if (badType) {
    return {
      accepted: [],
      error: {
        kind: 'type',
        message: 'Only JPG, PNG, GIF, and PDF files are allowed.',
      },
    };
  }

  const empty = incoming.find((f) => f.size === 0);
  if (empty) {
    return {
      accepted: [],
      error: { kind: 'empty', message: 'Empty files cannot be uploaded.' },
    };
  }

  const all = [...existing, ...incoming];
  if (all.length > MAX_FILES) {
    return {
      accepted: [],
      error: {
        kind: 'count',
        message: `You can attach up to ${MAX_FILES} files.`,
      },
    };
  }

  const total = all.reduce((sum, f) => sum + f.size, 0);
  if (total > MAX_TOTAL_BYTES) {
    return {
      accepted: [],
      error: { kind: 'size', message: 'Attachments must total 10 MB or less.' },
    };
  }

  return { accepted: incoming };
}
